import { useLocalization } from '@api/application-configuration';
import { updateLocalization } from '@unistocks/localization';
import { i18n } from '@unistocks/localization/i18n';
import { useAbpApplicationLocalizationGetQuery } from '@unistocks/proxy/axios-client/AbpApplicationLocalizationQuery';
import { Logger } from '@unistocks/shared/services/logger.service';
import { useEffect, useState } from 'react';

/**
 * Hook to load translations based on the current culture of the application.
 */
export const useTranslations = () => {
  const [state, setState] = useState<{ isLoaded: boolean; version: number }>({
    isLoaded: false,
    version: 1
  });
  const localizationConfig = useLocalization();
  const cultureName = localizationConfig?.currentCulture.cultureName;
  const defaultResourceName = localizationConfig?.defaultResourceName;

  const { data: localization, refetch } = useAbpApplicationLocalizationGetQuery(
    cultureName!,
    false,
    {
      enabled: !!cultureName,
      staleTime: 0
    }
  );

  useEffect(() => {
    const unsubscribe = i18n.onChange(instance => {
      setState({ isLoaded: true, version: instance.version });
    });

    if (localization && defaultResourceName) {
      Logger.debug('Updating localization', 'culture', localization.currentCulture.cultureName);
      updateLocalization(localization.currentCulture, defaultResourceName, localization.resources);
    }

    return () => {
      unsubscribe();
    };
  }, [defaultResourceName, localization]);

  return [state, refetch] as const;
};
